export const SCROLL_LINK_PROPS = {
  spy: true,
  smooth: true,
  offset: -80,
  duration: 500,
};

export const RENTAL_CATEGORIES = [
  {
    id: "short-term",
    title: "Short Term Rentals",
    description: "Available on a night by night basis",
    propertyIds: ["dome", "yurt"],
  },
  {
    id: "longer-stays",
    title: "Longer Stays",
    description:
      "Available for extended retreats or work-exchange opportunities",
    propertyIds: ["bus", "cabin"],
  },
];
